export const getBidIncrementValue = () => {
  return parseInt($('input#_bid-increment').val());
};

export const getMaxBidMetOrExceededTranslatedMessage = () => {
  return (
    $('input#max_bid_met_or_exceeded').attr('data-notification-text') || ''
  );
};

export const DEFAULT_TIMEOUT = 5000;

export const RETRY_TIMEOUT = 2500;

export const STATUS_RETRY_TIMEOUT = 500;

export const NO_TIMEOUT = 0;
